import { render, staticRenderFns } from "./AccountEdit.vue?vue&type=template&id=ddfe2718&scoped=true"
import script from "./AccountEdit.vue?vue&type=script&lang=js"
export * from "./AccountEdit.vue?vue&type=script&lang=js"
import style0 from "./AccountEdit.vue?vue&type=style&index=0&id=ddfe2718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfe2718",
  null
  
)

export default component.exports